var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgSearchi = function SvgSearchi(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z",
    "data-name": "Rectangle 1570"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    "data-name": "search icon"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Path 4861"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 5.5A5.5 5.5 0 1 1 5.5 11 5.5 5.5 0 0 1 11 5.5"
  })), /*#__PURE__*/React.createElement("path", {
    fill: props.color || 'currentColor',
    d: "M11 7.3c-2.04 0-3.7 1.66-3.7 3.7s1.66 3.7 3.7 3.7 3.7-1.66 3.7-3.7-1.66-3.7-3.7-3.7m0-1.8a5.5 5.5 0 1 1 0 11 5.5 5.5 0 0 1 0-11"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: props.color || 'currentColor',
    strokeLinecap: "round",
    strokeWidth: 1.8,
    d: "m18.5 18.5-4-4",
    "data-name": "Path 4556"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSearchi);
export default ForwardRef;